export const DEFAULT_FILL_OPACITY = 1;

export type FillOpacitySource = {
  fillOpacity?: unknown;
  fillColor?: unknown;
};

export const clampFillOpacity = (
  value: unknown,
  fallback = DEFAULT_FILL_OPACITY,
): number => {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return fallback;
  }

  return Math.min(Math.max(value, 0), 1);
};

/**
 * Returns the stored fill opacity while preserving older plans that encoded
 * transparency in a CSS-like fill-color string.
 */
export const resolveFillOpacity = (
  source: FillOpacitySource | undefined,
): number => {
  if (!source) return DEFAULT_FILL_OPACITY;

  if (typeof source.fillOpacity === "number") {
    return clampFillOpacity(source.fillOpacity);
  }

  if (typeof source.fillColor === "string") {
    const normalized = source.fillColor.trim().toLowerCase();
    if (normalized === "none" || normalized === "transparent") {
      return 0;
    }

    const rgbaMatch = normalized.match(
      /rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*([0-9]*\.?[0-9]+)\s*\)/,
    );
    if (rgbaMatch) {
      return clampFillOpacity(Number.parseFloat(rgbaMatch[1]));
    }
  }

  return DEFAULT_FILL_OPACITY;
};

